import { ClinicLocationType } from "../models";

import { ClinicLocationTypesAction } from "./actions";
import * as actionTypes from "./actionTypes";

export const clinicLocationTypes = (state: ClinicLocationType[] = [], action: ClinicLocationTypesAction): ClinicLocationType[] => {
    switch (action.type) {
        case actionTypes.LOAD_CLINIC_LOCATION_TYPES_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};
